const normalizeAnimalIdentity = (value) => String(value ?? '')
  .trim()
  .toLocaleLowerCase('ko-KR')
  .replace(/[\s_-]+/g, '');

// 동물 식별 정보만 프론트에 유지한다. 획득 영상은 API의 video_url을 사용한다.
export const QUEST_ANIMAL_REVEALS = Object.freeze([
  { key: 'capybara', displayName: '카피바라', aliases: [10, 'capybara', '카피바라'] },
  { key: 'toco-toucan', displayName: '토코투칸', aliases: [21, 'toco-toucan', 'toco_toucan', 'tocotoucan', '토코투칸'] },
  { key: 'fennec-fox', displayName: '사막여우', aliases: [14, 'fennec-fox', 'fennec_fox', 'fennecfox', '사막여우'] },
  { key: 'rabbit', displayName: '토끼', aliases: [19, 'rabbit', '토끼'] },
  { key: 'macaw', displayName: '금강앵무', aliases: [1, 'macaw', 'scarlet-macaw', 'scarlet_macaw', '금강앵무'] },
  { key: 'small-clawed-otter', displayName: '작은발톱수달', aliases: [24, 'small-clawed-otter', 'small_clawed_otter', 'smallclawedotter', '작은발톱 수달', '작은발톱수달'] },
  { key: 'humboldt-penguin', displayName: '훔볼트 펭귄', aliases: [25, 'humboldt-penguin', 'humboldt_penguin', 'humboldtpenguin', '훔볼트 펭귄', '훔볼트펭귄'] },
  { key: 'leopard-gecko', displayName: '레오파드 게코', aliases: [35, 'leopard-gecko', 'leopard_gecko', 'leopardgecko', '레오파드 게코', '레오파드게코'] },
  { key: 'prairie-dog', displayName: '프레리도그', aliases: [16, 'prairie-dog', 'prairie_dog', 'prairiedog', '프레리도그'] },
  { key: 'striped-squirrel', displayName: '줄무늬다람쥐', aliases: [3, 'striped-squirrel', 'striped_squirrel', 'stripedsquirrel', 'chipmunk', '줄무늬다람쥐'] },
].map((entry) => Object.freeze({
  ...entry,
  aliases: Object.freeze(entry.aliases.map(normalizeAnimalIdentity)),
})));

export function resolveQuestAnimalReveal({ animalId, animalName, animalVideoUrl } = {}) {
  const backendVideo = typeof animalVideoUrl === 'string' ? animalVideoUrl.trim() : '';
  if (!backendVideo) return null;

  const candidates = [animalId, animalName]
    .map(normalizeAnimalIdentity)
    .filter(Boolean);
  const matched = QUEST_ANIMAL_REVEALS.find((entry) => (
    candidates.some((candidate) => entry.aliases.includes(candidate))
  )) || null;

  return {
    key: matched?.key || `animal-${normalizeAnimalIdentity(animalId || animalName) || 'reward'}`,
    displayName: animalName || matched?.displayName || '',
    video: backendVideo,
    fallbackMs: 15000,
  };
}

export function shouldPresentQuestAnimalReward(animalRewardStatus) {
  return !animalRewardStatus
    || animalRewardStatus === 'granted'
    || animalRewardStatus === 'already_granted';
}
